import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import Button from 'components/shared/Button/Button'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'

import './CoolestProjects.scss'
import sliceImage from './images/projects.png'

const CoolestProjects = ({
  endDate,
  t,
  i18n: { language: locale },
  gtm = {},
}) => {
  const sendDataToGTM = useGTMDispatch()
  const handleClick = () =>
    sendDataToGTM({ ...gtm, label: 'Coolest Projects slice' })

  const dateLocale = locale === 'en' ? 'en-GB' : locale

  const formattedDate = endDate.toLocaleDateString(dateLocale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

  return (
    <div className="coolest-projects__wrapper">
      <div className="coolest-projects">
        <img
          alt="Editor slice"
          className="coolest-projects__image"
          src={sliceImage}
        />
        <div className="coolest-projects__copy">
          <h3>{t('project.coolest-projects.title')}</h3>
          <p className="coolest-projects__copy--bottom">
            {t('project.coolest-projects.description')}
          </p>
          <p>
            <strong>
              {t('project.coolest-projects.description-secondary', {
                endDate: formattedDate,
              })}
            </strong>
          </p>
          <Button
            type="primary"
            text={t('project.coolest-projects.button')}
            href={'https://online.coolestprojects.org/take-part'}
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  )
}

CoolestProjects.propTypes = {
  endDate: PropTypes.instanceOf(Date).isRequired,
  gtm: PropTypes.object,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export { CoolestProjects }
export default translate('translations')(CoolestProjects)
